export default function OddsCell({ text, highlight }) {
  let classes = 'px-1.5 py-0.5 rounded text-[14px] font-medium transition-colors duration-150 ';
  classes += "font-[family-name:var(--font-mono)] ";

  if (highlight === 'best') {
    classes += 'text-[#029456] bg-[#E6F5EC] dark:text-[#34d399] dark:bg-[rgba(16,185,129,0.1)]';
  } else if (highlight === 'worst') {
    classes += 'text-[#DC2626] bg-[#FEF0F0] dark:text-[#ef4444] dark:bg-[rgba(239,68,68,0.1)]';
  } else {
    classes += 'text-[#1F2937] dark:text-[#e2e8f0]';
  }

  return <span className={classes}>{text}</span>;
}
